import axios from "axios";

export default class API {

    static login(requestPath, data, setAuthentication, setErrorMessage, callbackFn)  {
        const options = {
            method: 'post',
            url: requestPath,
            data: data,
            headers: {
                'Authorization': '',
                'Content-Type': "application/json",
                'Accept': "application/json",
                'Access-Control-Allow-Origin': requestPath
            }
        };

        axios(options)
            .then(response => {
                const auth = {
                    authToken: response.headers['authorization'],
                    currentUser: response.data
                }
                setAuthentication(auth);
                setErrorMessage(null);
                if (callbackFn) {
                    callbackFn();
                }
            })
            .catch(error => {
                if (typeof(error.response) !== 'undefined' && error.response.status === 401) {
                    setErrorMessage('Your entries do not match the credentials of an active user');
                } else if (typeof(error.response) !== 'undefined' && error.response.status === 406) {
                    setErrorMessage('Your password expired. Use link bellow to reset your password');
                } else if (typeof(error.response) !== 'undefined' && error.response.status === 429) {
                    setErrorMessage('Your account is temporarily disabled due to too many unsuccessful login attempts, try again later.');
                } else {
                    setErrorMessage(error.message);
                }
                if (callbackFn) {
                    callbackFn();
                }
            });
    }

    static postRetrieve(requestPath, data, dataDescription, authToken, setActionResponse) {
        const options = {
            method: 'post',
            url: requestPath,
            data: data,
            timeout: 240000,
            defaults: {timeout: 240000},
            headers: {
                'Authorization': authToken,
                'Content-Type': "application/json",
                'Accept': "application/json",
                'Access-Control-Allow-Origin': requestPath
            }
        };

        axios(options)
            .then(response => {
                let actionResponse;
                if (response.data && !response.data.error && (dataDescription === 'users')) {
                    actionResponse = {
                        data: response.data,
                        error: false,
                        requestType: dataDescription,
                    }
                } else if (response.data) {
                    actionResponse = response.data;
                    actionResponse.requestType = dataDescription;
                } else {
                    actionResponse = {
                        error: true,
                        errorMessage: 'No response data received',
                        requestType: dataDescription
                    };
                }
                setActionResponse(actionResponse);
            })
            .catch(error => {
                const serverMessage = error.response?.data?.errorMessage ?? error.response?.data?.message;
                const message = serverMessage
                    ? serverMessage
                    : (error.response?.status === 401
                        ? 'Unauthorized request'
                        : (error.message ?? 'An error occurred processing your request'));
                const actionResponse = {
                    error: true,
                    message: message,
                    errorMessage: message,
                    requestType: dataDescription
                };
                setActionResponse(actionResponse);
            });
    }

    static getRetrieve(requestPath, dataDescription, authToken, setActionResponse) {
        const headers = {
            'Authorization': authToken,
            'Accept': "application/json",
            'Access-Control-Allow-Origin': requestPath
        };

        axios.get(requestPath, { headers })
            .then(response => {
                let actionResponse = null;
                if (response.data && response.data.error) {
                    actionResponse = response.data;
                } else if (dataDescription === 'agencies') {
                    actionResponse = {
                        data: response.data,
                        error: false,
                        message: dataDescription,
                    }
                } else {
                    actionResponse = response.data;
                    actionResponse.message = dataDescription;
                    actionResponse.requestType = dataDescription;
                }
                setActionResponse(actionResponse);
            })
            .catch(error => {
                let message = '';
                if (typeof(error.response) !== 'undefined' && error.response.status === 401) {
                    message = 'Your entries do not match the credentials of an active user';
                } else {
                    message = error.message;
                }
                const actionResponse = {
                    error: true,
                    message: message,
                    errorMessage: message
                };
                setActionResponse(actionResponse);
            });
    }

    static postForFile(requestPath, data, dataDescription, authToken, setFileResponse) {
        const options = {
            method: 'post',
            responseType: 'blob',
            url: requestPath,
            data: data,
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': "application/json",
                'Accept': ["application/pdf","application/json"],
                'Access-Control-Allow-Origin': requestPath
            }
        };

        axios(options)
            .then(response => {
                if (response.data) {
                    setFileResponse(response.data);
                } else {
                    const actionResponse = {
                        error: true,
                        errorMessage: (response.data.message),
                        requestType: dataDescription
                    }
                    setFileResponse(actionResponse);
                }
            })
            .catch(error => {
                const message = (typeof(error.response) !== 'undefined' && error.response.status === 401) ?
                    'Your session has expired and you must login again' :
                    `An error occurred processing your request: ${error.message}`;
                const actionResponse = {
                    error: true,
                    errorMessage: message
                };
                setFileResponse(actionResponse);
            });
    }
}